import { DiscountTypeEnum } from 'common/enums';

export const DiscountTypeList = [
  { value: DiscountTypeEnum.Percentage, label: 'Percentage'},
  { value: DiscountTypeEnum.Dollars, label: 'Dollars'}
];
